import React from 'react';

export const StylePropType = React.PropTypes.object; // eslint-disable-line react/forbid-prop-types, import/prefer-default-export

export const transitionFunction = 'ease-in-out';

export const transitionDuration = '150ms';

export const zIndexBelowContent = 0;
export const zIndexContent = 10;
export const zIndexAboveContent = 20;

export const chatAppHeightPercentage = 100;
export const footerHeightPercentage = 4;
export const chatRoutePercentage = chatAppHeightPercentage - footerHeightPercentage;
